import React from 'react'
import {Alert} from 'react-bootstrap'

const GlobalMessage = ({info, error, resetGlobalInfo, resetGlobalError}) =>
    <div className="GlobalMessage">
        { (info &&
            <Alert onClose={resetGlobalInfo} variant="info">{info}</Alert>)
            || (error &&
            <Alert onClose={resetGlobalError} variant="danger">{error}</Alert>)
        }
    </div>

export default GlobalMessage;